import React from "react";
import Base64Downloader from "common-base64-downloader-react";
import { IoMdDocument } from "react-icons/io";
import { FaDownload } from "react-icons/fa";

type props = {
  documentContent: any;
  documentName: string;
};

const SingleDocument = (props: props) => {
  const { documentContent, documentName } = props;

  return (
    <li>
      <Base64Downloader
        base64={"data:application/pdf;base64," + documentContent}
        downloadName={documentName}
        className="fileDownloader"
      >
        <FaDownload /> {documentName}
      </Base64Downloader>
    </li>
  );
};

export default SingleDocument;
